import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { extrasVM } from '../Extras.page';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { IconButton } from '@design-system/components/button/iconButton';
import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { ExtrasFilters } from './ExtrasFilters';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { BasicMenu } from '@client/new/components/BasicMenu/BasicMenu';
import { toExtrasMenuItems } from '../viewModel/extras.mappers';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { Alert } from '@design-system/components/alert/alert';
import { disabled } from '../../../../components/SuperTooltip/components/NavigationButton.css';

export const ExtrasHeader = () => {
  const [isChanged, setIsChanged] = useState(false);
  const vm = extrasVM.useValue();

  const handleToggleChange = (id: string) => {
    setIsChanged(true);
    vm.dispatch('ToggleItemVisible', id);
    setTimeout(() => {
      setIsChanged(false);
    }, 500);
  };

  const tabs = vm.contentIds.items || [];
  const currentTab = tabs[0];
  if (!currentTab) return null;

  const tabContent = vm.contentMap[currentTab.id];

  if (!tabContent || tabContent.type !== 'ContentTab') return null;

  return (
    <Col gap="xl">
      <Row>
        <Typography variant="headline" size="large">
          Extras
        </Typography>
      </Row>
      <Row alignCenter gap="xl">
        {tabs.map((tab) => {
          const content = vm.contentMap[tab.id];
          if (content.type !== 'ContentTab') return null;
          return (
            <IconButton
              key={content.value.id}
              onClick={() => vm.dispatch('Edit', content.value.id)}
              variant="filled"
              color="neutral"
              icon={faPencil}
              style={{
                flexDirection: 'row-reverse',
                borderRadius: '16px',
                padding: '4px 8px 4px 12px',
              }}
            >
              <Typography variant="title" size="large">
                {content.value.name}
              </Typography>
            </IconButton>
          );
        })}
        <SuperTooltip templateId="extras-details" />
      </Row>

      <Row alignCenter>
        <Row gap="2xl">
          <Typography variant="body" size="large">
            In-app visibility:
          </Typography>
          <Row>
            <Typography variant="body" size="large">
              {tabContent.value.isPublished && !vm.isExtrasEmpty ? 'ON' : 'OFF'}
            </Typography>
            <Toggle
              value={vm.isExtrasEmpty ? false : tabContent.value.isPublished}
              onChange={() => handleToggleChange(tabContent.value.id)}
              variant="primary"
              disabled={vm.isExtrasEmpty}
            />
            {isChanged && <CircularProgress size={20} />}
          </Row>
        </Row>

        <Row className="ml-auto">
          <BasicMenu
            testId="extras-create-menu"
            title="New"
            items={toExtrasMenuItems(vm.dispatch)}
          />
        </Row>
      </Row>
      {vm.isExtrasEmpty && (
        <Alert
          variant="info"
          title="This tab is not visible to your users when empty"
          details="Create some content using the button below to make your tab visible."
        />
      )}

      {!vm.isExtrasEmpty && <ExtrasFilters />}
    </Col>
  );
};
